var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_4066_104513)",
    filter: "url(#filter0_d_4066_104513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0175 28.125C25.5202 28.125 25.0433 28.3225 24.6917 28.6742C24.34 29.0258 24.1425 29.5027 24.1425 30V35.625C24.1425 37.1168 23.5499 38.5476 22.495 39.6025C21.4401 40.6574 20.0093 41.25 18.5175 41.25H13.875C12.3832 41.25 10.9524 40.6574 9.89752 39.6025C8.84263 38.5476 8.25 37.1168 8.25 35.625V9.375C8.25 7.88316 8.84263 6.45242 9.89752 5.39752C10.9524 4.34263 12.3832 3.75 13.875 3.75H18.5175C20.0093 3.75 21.4401 4.34263 22.495 5.39752C23.5499 6.45242 24.1425 7.88316 24.1425 9.375V15C24.1425 15.4973 24.34 15.9742 24.6917 16.3258C25.0433 16.6775 25.5202 16.875 26.0175 16.875C26.5148 16.875 26.9917 16.6775 27.3433 16.3258C27.695 15.9742 27.8925 15.4973 27.8925 15V9.375C27.8895 6.88951 26.9008 4.50667 25.1433 2.74916C23.3858 0.991654 21.003 0.00297723 18.5175 0H13.875C11.3895 0.00297723 9.00667 0.991654 7.24916 2.74916C5.49165 4.50667 4.50298 6.88951 4.5 9.375L4.5 35.625C4.50298 38.1105 5.49165 40.4933 7.24916 42.2508C9.00667 44.0083 11.3895 44.997 13.875 45H18.5175C21.003 44.997 23.3858 44.0083 25.1433 42.2508C26.9008 40.4933 27.8895 38.1105 27.8925 35.625V30C27.8925 29.5027 27.695 29.0258 27.3433 28.6742C26.9917 28.3225 26.5148 28.125 26.0175 28.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3761 18.5227L38.7774 9.92398C38.6044 9.7449 38.3975 9.60205 38.1687 9.50379C37.94 9.40552 37.694 9.3538 37.445 9.35163C37.196 9.34947 36.9491 9.39691 36.7187 9.49119C36.4883 9.58546 36.2789 9.72469 36.1029 9.90074C35.9268 10.0768 35.7876 10.2861 35.6933 10.5166C35.5991 10.747 35.5516 10.9939 35.5538 11.2429C35.5559 11.4918 35.6077 11.7379 35.7059 11.9666C35.8042 12.1954 35.947 12.4023 36.1261 12.5752L44.1192 20.5684L15.7505 20.6246C15.2532 20.6246 14.7763 20.8221 14.4247 21.1738C14.073 21.5254 13.8755 22.0023 13.8755 22.4996C13.8755 22.9969 14.073 23.4738 14.4247 23.8254C14.7763 24.1771 15.2532 24.3746 15.7505 24.3746L44.228 24.3184L36.1224 32.424C35.9433 32.5969 35.8004 32.8038 35.7022 33.0326C35.6039 33.2614 35.5522 33.5074 35.55 33.7564C35.5479 34.0053 35.5953 34.2522 35.6896 34.4826C35.7839 34.7131 35.9231 34.9224 36.0991 35.0985C36.2752 35.2745 36.4845 35.4137 36.715 35.508C36.9454 35.6023 37.1923 35.6497 37.4412 35.6476C37.6902 35.6454 37.9362 35.5937 38.165 35.4954C38.3938 35.3972 38.6007 35.2543 38.7736 35.0752L47.3724 26.4765C48.4274 25.4221 49.0205 23.9919 49.0212 22.5004C49.0219 21.0088 48.4301 19.5781 47.3761 18.5227Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4066_104513",
    x: 0.5,
    y: 0,
    width: 53,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_104513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_104513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4066_104513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9c41bbee084e8c235cfd923882f2dc6a.svg";
export { ForwardRef as ReactComponent };